var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 21",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95835 1.33301H16.3334V19.6663H3.95835C3.35057 19.6663 2.76767 19.4249 2.3379 18.9951C1.90813 18.5654 1.66669 17.9825 1.66669 17.3747V3.62467C1.66669 3.01689 1.90813 2.43399 2.3379 2.00422C2.76767 1.57445 3.35057 1.33301 3.95835 1.33301Z",
    fill: "#80D6F3",
    stroke: "#00ADE6",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 17.3747C1.66669 16.7669 1.90813 16.184 2.3379 15.7542C2.76767 15.3245 3.35057 15.083 3.95835 15.083H16.3334",
    stroke: "#00ADE6",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/courseIcon.e8bf3413.svg";
export { SvgComponent as ReactComponent };